module.exports = __webpack_public_path__ + "img/IMG_9458_59_60_L.8cf1bb40.webp";